import { render, staticRenderFns } from "./XrImport.vue?vue&type=template&id=2e3fd408&scoped=true&"
import script from "./XrImport.vue?vue&type=script&lang=js&"
export * from "./XrImport.vue?vue&type=script&lang=js&"
import style0 from "./XrImport.vue?vue&type=style&index=0&id=2e3fd408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fd408",
  null
  
)

component.options.__file = "XrImport.vue"
export default component.exports